import React, { Fragment } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Drawer } from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import Hidden from '@material-ui/core/Hidden';
import SidebarNav from './SidenavBar';
import {AuthContext} from '../../../../auth/AuthContext';
import Profile from './Profile';
import ExitToAppSharpIcon from '@material-ui/icons/ExitToAppSharp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

const useStyles = makeStyles(theme => (
  {
  drawer: {
    width: 240
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
  
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const {user} = React.useContext(AuthContext);
  const classes = useStyles();

  const pages = [
    {
      title: 'Orders',
      href: '/orders',
      icon: <ListAltIcon />
    },
    {
      title: 'Reports',
      href: '/reports',
      icon: <AssessmentIcon />
    },
    {
      title: 'Settings',
      href: '/settings',
      icon: <SettingsIcon />
    },
    {
      title: 'Users',
      href: '/users',
      icon: <PeopleAltIcon />
    },
    // {
    //   title: 'Payments',
    //   href: '/payments',
    //   icon: <PaymentIcon />
    // },
    // {
    //   title: 'Messages',
    //   href: '/_hidden/contacts',
    //   icon: <MessageSharpIcon />
    // },
    // {
    //   title: 'Settings',
    //   href: '/_hidden/settings',
    //   icon: <SettingsSharpIcon />
    // },
    {
      title: 'Logout',
      href: '/logout',
      icon: <ExitToAppSharpIcon />
    }
  ];

  return (
    <Fragment>
       <Hidden smUp implementation="css">
          <Drawer
            anchor="left"
            classes={{ paper: classes.drawer }}
            onClose={onClose}
            open={open}
            variant={variant === 'responsive' ? 'temporary' : variant}
          >
            <div
              {...rest}
              className={clsx(classes.root, className)}
            >
              <Profile user={user}/>
              <SidebarNav
                className={classes.nav}
                pages={pages}
              />
            </div>
          </Drawer>
        </Hidden>
        { variant === 'responsive' &&
          <Hidden xsDown implementation="css">
            <Drawer
              anchor="left"
              variant="permanent"
              classes={{ paper: classes.drawer }}
            >
              <div
                {...rest}
                className={clsx(classes.root, className)}
              >
                <Divider className={classes.divider} />
                <SidebarNav
                  className={classes.nav}
                  pages={pages}
                />
              </div>
            </Drawer>
        </Hidden>
        }
    </Fragment>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;